import { render, staticRenderFns } from "./_PositionTemplate.vue?vue&type=template&id=ed6bbe90&"
import script from "./_PositionTemplate.vue?vue&type=script&lang=js&"
export * from "./_PositionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./_PositionTemplate.vue?vue&type=style&index=0&id=ed6bbe90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports